module.exports = __webpack_public_path__ + "static/media/InfoIcon2.92a4bc94.png";